import React from "react";
import { useIntl } from "react-intl";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

export default function AudienceInterestsInput({
  searchTopicInputValue,
  onChangeSearchTopicInputValue,
  onKeyPress,
  children,
  isDisabled,
}) {
  const intl = useIntl();

  return (
    <div className="audience-search__field">
      <div className="audience-search__input">
        <div className="idh-label">
          <IDHFormattedMessage
            id="front_audience_interests"
            defaultMessage="Audience interests"
          />
        </div>
        <div className="audience-search__input-wrapper">
          <input
            placeholder={intl.formatMessage({
              id: "front_search_topic_placeholder",
              defaultMessage: "Search topic...",
            })}
            value={searchTopicInputValue}
            onKeyPress={onKeyPress}
            onChange={onChangeSearchTopicInputValue}
            disabled={isDisabled}
            data-cdt-input="audience-interests"
          />
          {children}
        </div>
      </div>
    </div>
  );
}
